import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4cdthxubt5: FaireBrandEntity = {
  token: "b_4cdthxubt5",
  type: "brand",
  name: "Half Pint Studio",
  avatarUrl:
    "https://cdn.faire.com/fastly/f1a958ff2c8da5fb53e3472b054491649e4cad5657975bf1244ae6a92f83605b.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/22c82afe00a6eb2083f85e39c7e46522994726a50cd607e382f6bacc0f8ed67c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f1a958ff2c8da5fb53e3472b054491649e4cad5657975bf1244ae6a92f83605b.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/22c82afe00a6eb2083f85e39c7e46522994726a50cd607e382f6bacc0f8ed67c.jpeg",
  location: "Salt Lake City, UT, USA",
  minimumOrderDollars: 125,
  rating: 5,
  reviewCount: 11,
  isTopShop: true,
  isInsider: true,
  description:
    "Half Pint Studio is a small boutique letterpress and foil stamping studio in the heart of Salt Lake City, Utah run by husband and wife team, Sky and Allison. They specialize in bringing the tactile art of old world printing practices into the hands of the everyday modern person through thoughtful and celebratory greeting cards. ",
  meta: {
    source: "api",
    importedAt: "2026-07-31T16:23:58.349Z",
    importedBy: "entity-db-cli",
  },
};
